var _defs, _rect, _circle, _circle2, _g, _g2, _path, _path2, _g3, _g4, _g5, _path3, _g6, _g7, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampoFazendaBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1080",
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2E5266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32%",
    stopColor: "#4F7C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "58%",
    stopColor: "#E8A24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#F6C878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FBE0A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scrim",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#152430",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22%",
    stopColor: "#152430",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#152430",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sunGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF3D6",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#FFD98A",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFD98A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hillFar",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7F9A82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6C8C6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hillMid",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5A7D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4C6E45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rowsA",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6E9A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#587E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rowsB",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F7A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3E6328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "foreground",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3B5C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#243A18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barnWood",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6B3A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4E2A21"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1920,
    height: 720,
    fill: "url(#sky)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1080,
    cy: 545,
    r: 260,
    fill: "url(#sunGlow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1080,
    cy: 545,
    r: 68,
    fill: "#FFEFC2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF5DF",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 180,
    rx: 140,
    ry: 26
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 410,
    cy: 170,
    rx: 100,
    ry: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 900,
    cy: 120,
    rx: 170,
    ry: 24
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1300,
    cy: 150,
    rx: 130,
    ry: 20
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#2E4433",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760,240 q14,-16 28,0 q14,-16 28,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820,280 q12,-14 24,0 q12,-14 24,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180,210 q13,-15 26,0 q13,-15 26,0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,650 C300,580 500,610 760,590 C1050,568 1300,600 1600,570 C1750,556 1850,570 1920,560 L1920,720 L0,720 Z",
    fill: "url(#hillFar)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,700 C260,650 480,690 720,665 C1000,636 1260,672 1560,648 C1730,634 1840,648 1920,640 L1920,760 L0,760 Z",
    fill: "url(#hillMid)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 858,
    y: 560,
    width: 46,
    height: 130,
    rx: 23,
    fill: "#7C4B3A"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "858,560 881,530 904,560",
    fill: "#5C3628"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 610,
    width: 120,
    height: 80,
    fill: "url(#barnWood)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "750,610 820,565 890,610",
    fill: "#3E2018"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 650,
    width: 28,
    height: 40,
    fill: "#2E1811"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#3E2A1E",
    strokeWidth: 5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 700,
    x2: 1920,
    y2: 700,
    strokeDasharray: "2,10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 672,
    x2: 700,
    y2: 712
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 672,
    x2: 960,
    y2: 712
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,760 L900,700 L1020,700 L1920,760 L1920,830 L0,830 Z",
    fill: "url(#rowsA)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,830 L920,748 L1000,748 L1920,830 L1920,900 L0,900 Z",
    fill: "url(#rowsB)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#EFE7B8",
    strokeOpacity: 0.16,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 0,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 200,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 400,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 600,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 800,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 1120,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 1320,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 1520,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 1720,
    y2: 900
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 700,
    x2: 1920,
    y2: 900
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,900 L960,838 L1920,900 L1920,1080 L0,1080 Z",
    fill: "url(#foreground)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#8FAE5A",
    strokeOpacity: 0.2,
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 838,
    x2: -160,
    y2: 1080
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 838,
    x2: 100,
    y2: 1080
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 838,
    x2: 380,
    y2: 1080
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 838,
    x2: 660,
    y2: 1080
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 838,
    x2: 940,
    y2: 1080
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 838,
    x2: 1220,
    y2: 1080
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 838,
    x2: 1500,
    y2: 1080
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 838,
    x2: 1780,
    y2: 1080
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 838,
    x2: 2060,
    y2: 1080
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#6E9145",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 700,
    cy: 1010,
    rx: 10,
    ry: 22
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 750,
    cy: 1030,
    rx: 10,
    ry: 22
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1000,
    cy: 1000,
    rx: 10,
    ry: 22
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1050,
    cy: 1024,
    rx: 10,
    ry: 22
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 620,
    cy: 1005,
    rx: 10,
    ry: 22
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1150,
    cy: 1005,
    rx: 10,
    ry: 22
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1920,
    height: 480,
    fill: "url(#scrim)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampoFazendaBg);
export default __webpack_public_path__ + "static/media/campo-fazenda-bg.170ecac55e5870ef355193fb0c939c7f.svg";
export { ForwardRef as ReactComponent };